import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import axios, { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { Book, Search } from "react-bootstrap-icons";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";

import Header from "../../../components/Headers/Header";
import ConfirmModal from "../../../components/Modals/ConfirmModal";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";

import useTeacherMedium from "../../../Hooks/useTeacherMedium";
import useTeacherProfile from "../../../Hooks/useTeacherProfile";
import { PATHS } from "../../../routes";
import { TypeTeacherSchool } from "../../../Reducers/types";
import { createMarkup } from "../../../Services/utils";
import {
  TypeAssessmentAttempt,
  TypeAssessmentInfo,
  typeGradeSection,
  TypeNotification,
  TypeQuestionAttempt,
  TypeQuestions,
  TypeSubject,
  TypeTopic,
} from "../../../types";
import {
  addHomeworkAssessment,
  addQuestionsToAssessment,
  createNotification,
  createQuestionAttemptsForAllStudents,
  // filterQuestions,
  getAllStudents,
  getQuestions,
  getTopics,
  postAssessmentForAllStudents,
} from "../../../Services/Assessment/AssessmentService";

export default function Assessment() {
  const history = useHistory();
  const userInformation = useSelector(
    (state: any) => state.user.userInformation
  ); // gets teacher information forom rredux-store
  const teacherMedium: number = useTeacherMedium(); // stores medium of logged in teacher
  const teacherProfile: TypeTeacherSchool = useTeacherProfile(); // stores teacher profile information

  // --- DROPDOWN ASSESSMENT TYPE ---
  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);
  const assessmentTypeToggle = () =>
    setTypeDropdownOpen((prevState) => !prevState);
  // --- DROPDOWN GRADE ---
  const [gradeDropdownOpen, setGradeDropdownOpen] = useState(false);
  const gradeDropdownToggle = () =>
    setGradeDropdownOpen((prevState) => !prevState);
  // --- DROPDOWN SUBJECT ---
  const [subjectDropdownOpen, setSubjectDropdownOpen] = useState(false);
  const subjectDropdownToggle = () =>
    setSubjectDropdownOpen((prevState) => !prevState);
  // --- DROPDOWN TOPICS ---
  const [topicDropdownOpen, setTopicDropdownOpen] = useState(false);
  const topicDropdownToggle = () =>
    setTopicDropdownOpen((prevState) => !prevState);
  // --- QUESTION LIMIT DROPDOWN ---
  const [questionLimitOpen, setQuestionLimitOpen] = useState(false);
  const questionLimitToggle = () =>
    setQuestionLimitOpen((prevState) => !prevState);

  // --- HOMEWORK QUESTIONS MODAL CONTROL STATES ---
  const [homeworkModal, setHomeworkModal] = useState(false);
  const homeworkModalToggle = () => setHomeworkModal(!homeworkModal);
  // --- CONFIRMATION MODAL FOR ADD ASSESSMENT ---
  const [confirmAddAssessmentModal, setConfirmAddAssessmentModal] =
    useState(false);
  const confirmAddAssessmentModalToggle = () =>
    setConfirmAddAssessmentModal(!confirmAddAssessmentModal);

  const [assessmentType, setAssessmentType] = useState<string>("assessment"); // stores type of assessment : assessment and homework
  // --- GRADE-SECTION-SUBJECT ---
  const [gradeSectionInfo, setGradeSectionInfo] = useState<typeGradeSection[]>(
    []
  ); // stores grade-section-subject information
  const [selectedGrade, setSelectedGrade] = useState<typeGradeSection>(); // stores selected grade
  // --- SUBJECTS ---
  const [subjects, setSubjects] = useState<TypeSubject[]>([]); // stores subject list
  const [selectedSubject, setSelectedSubject] = useState<TypeSubject>(); // stores id of selected subject
  // --- QUESTION LIMIT ---
  const questionLimit: number[] = Array.from(
    { length: 16 },
    (_, index) => index + 4 + 1
  ); // stores number of questions from 5 - 20
  const [selectedQuestionLimit, setSelectedQuestionLimit] = useState<number>(5); // stores selected question limit from questionLimit dropdown

  // --- TOPICS ---
  const [topics, setTopics] = useState<TypeTopic[]>(); // stores topic list
  const [selectedMultipleTopics, setSelectedMultipleTopics] = useState<
    TypeTopic[]
  >([]);

  const [selectedTopics, setSelectedTopics] = useState<TypeTopic>();
  const addSelectedTopics = (topic) => {
    setSelectedTopics(topic);
  };

  // --- HOMEWORK ---
  const [homeworkQuestions, setHomeworkQuestions] = useState<TypeQuestions[]>(
    []
  ); // stores all the questions fetched from DB
  const [selectedQuestions, setSelectedQuestions] = useState<TypeQuestions[]>(
    []
  ); // stores selected questions for homework assessment
  const [filteredQuestions, setFilteredQuestions] = useState<TypeQuestions[]>(
    []
  ); // stores filtered question list based on query

  // --- FOR HOMEWORK-ASSESSMENT ADD ---
  const [assessmentStartDate, setAssessmentStartDate] = useState<string>(
    new Date().toISOString().split(".")[0].split("T")[0].concat("T00:00:00")
  ); // stores starting date for searching
  const [assessmentEndDate, setAssessmentEndDate] = useState<string>(""); // stores end date for searching
  const [assessmentTime, setAssessmentTime] = useState<number>(5); // stores total number of question selected by teacher
  const [assessmentTitle, setAssessmentTitle] = useState<string>(""); // stores the title of the assessment-homework
  const [assessmentDescription, setAssessmentDescription] =
    useState<string>(""); // stores description of the assessment-homework
  const [homeworkURL, setHomeworkURL] = useState<string>(""); // stores URL for homework type assessment

  // --- LOADIG ---
  const [searchQuestionQuery, setSearchQuestionQuery] = useState<string>(""); // stores the query tha is used to search questions
  const [isQuestionLoading, setIsQuestionLoading] = useState<boolean>(false); // if questions are getting searched - true
  const [isLoading, setIsLoading] = useState<boolean>(false); // when 'true' shows loading button for add assessment button

  const [totalMarks, setTotalMarks] = useState<number>(); // stores total marks for selected questions
  const [isOptionOpen, setIsOptionOpen] = useState<number>(-1); // index of the question-option to be shown
  const [isViewOptionOpen, setIsViewOptionOpen] = useState<number>(-1); // index of the selected question-option to be shown

  useEffect(() => {
    filterGrades();
  }, []);
  useEffect(() => {
    filterSubjects();
    setSelectedSubject(null);
    setSelectedQuestions([]);
    setTotalMarks(0);
    setFilteredQuestions([]);
  }, [selectedGrade]);
  useEffect(() => {
    getTopicsList();
    // setSelectedTopics(null);
    setSelectedMultipleTopics([]);
    setSelectedQuestions([]);
    setTotalMarks(0);
    setFilteredQuestions([]);
  }, [selectedGrade, selectedSubject]);
  useEffect(() => {
    setSelectedQuestions([]);
    setTotalMarks(0);
    setFilteredQuestions([]);
  }, [selectedMultipleTopics]);
  // fetches question when parameters are changed
  useEffect(() => {
    fetchQuestions();
  }, [selectedMultipleTopics]);
  // selectedGrade?.grade_section_id?.grade?.id, selectedSubject?.subject_id?.id,
  useEffect(() => {
    if (selectedQuestionLimit < selectedQuestions?.length) {
      setSelectedQuestions([]);
      setTotalMarks(0);
    }
  }, [selectedQuestionLimit, selectedQuestions]);

  // filters grades from teacher profile
  const filterGrades = () => {
    if (Number(teacherProfile?.gradelist.length) === 0) {
      toast.error("Can not get grades. Please log in again!");
    }
    // ** filters grade-section based on current session(year) **
    setGradeSectionInfo(
      teacherProfile?.gradelist?.filter(({ grade_section_id, subject }) => {
        if (
          moment(new Date()).format("YYYY-MM-DD") >=
            moment(grade_section_id?.session?.session_start).format(
              "YYYY-MM-DD"
            ) &&
          moment(new Date()).format("YYYY-MM-DD") <=
            moment(grade_section_id?.session?.session_end).format("YYYY-MM-DD")
        ) {
          return { grade_section_id, subject };
        }
      })
    );
  };
  // filters subjects from teacher profile
  const filterSubjects = () => {
    let localSubjects: any = [];
    gradeSectionInfo?.forEach((each) => {
      if (
        each?.grade_section_id?.grade?.id ===
          selectedGrade?.grade_section_id?.grade?.id &&
        each?.grade_section_id?.section?.id ===
          selectedGrade?.grade_section_id?.section?.id
      ) {
        localSubjects.push(each?.subject);
      }
    });
    setSubjects(localSubjects.flat());
  };

  // *** DATA FETCH STARTS ***
  // fetches questions based on filters
  // fetches topic list
  const getTopicsList = () => {
    getTopics(
      selectedGrade?.grade_section_id?.grade?.id,
      selectedSubject?.subject_id?.id,
      teacherMedium
    )
      .then(
        (response) => {
          // console.log("Response For Topic List: ", response?.data?.data);
          setTopics(response?.data?.data);
        },
        (error) => {
          console.log("Error caught: ", error?.response);
        }
      )
      .catch((error) => console.log("Catched Error ---> ", error));
  };
  const fetchQuestions = () => {
    let topicIds: number[] = selectedMultipleTopics?.map(({ id }) => {
      return id;
    });

    getQuestions(
      selectedGrade?.grade_section_id?.grade?.id,
      selectedSubject?.subject_id?.id,
      String(topicIds.join(","))
    )
      .then(
        (response: AxiosResponse) => {
          // console.log("Response For Question List: ", response?.data?.data);
          setHomeworkQuestions(response?.data?.data);
        },
        (error) => {
          console.log("Error caught: ", error?.response);
          toast.error("Can not fetch questions!");
        }
      )
      .catch((error) => console.log("Catched error ---> ", error));
  };
  // *** DATA FETCH ENDS ***

  // --- QUESTIONARY STARTS ---
  const addSelectedMultipleTopics = (topic: TypeTopic) => {
    selectedMultipleTopics?.filter((each) => each?.id === topic?.id).length ===
    0
      ? setSelectedMultipleTopics((oldData) => [...oldData, topic])
      : console.log();
  };
  // adds a new question to selected question list
  const addSelectedQuestions = (question: TypeQuestions) => {
    selectedQuestions?.filter((item) => item.id == question.id).length == 0
      ? setSelectedQuestions([...selectedQuestions, question])
      : toast.error(`You have already added this question!`);
  };
  // removes a question form selected question list
  const removeSelectedQuestion = (question: TypeQuestions) => {
    let newQuestionList: TypeQuestions[] = selectedQuestions?.filter((item) => {
      return item.id !== question.id;
    });
    setSelectedQuestions(newQuestionList);
  };
  // --- QUESTIONARY ENDS ---

  // *** CREATES NEW ASSESSMENT STARTS ***
  const addAssessmentInfo = () => {
    setIsLoading(true);
    // closing confirmation modal
    confirmAddAssessmentModalToggle();
    // formation of ids of questions
    // let questionIds: any = selectedQuestions?.map(({ id }) => {
    //     return { "question_id": { "id": id } };
    // });

    // formation of ids of topics
    let topicIds: any = selectedMultipleTopics?.map(({ id }) => {
      return { topic_id: { id: id } };
    });

    // format data to create assessment/homework
    // let assessmentData: TypeAssessmentInfo = {
    //   // status: 'published',
    //   assigned_by: userInformation?.id,
    //   title: assessmentTitle,
    //   description: assessmentDescription,
    //   start_date: moment(assessmentStartDate).format("YYYY-MM-DD HH:mm:ss"),
    //   end_date: moment(assessmentEndDate).format("YYYY-MM-DD HH:mm:ss"),
    //   total_time: assessmentType === "assessment" ? assessmentTime ?? 0 : 0,
    //   grade: selectedGrade?.grade_section_id?.id,
    //   subject: selectedSubject?.subject_id?.id,
    //   no_of_questions: selectedQuestions?.length, // selectedQuestionLimit
    //   total_marks: selectedQuestions?.reduce(
    //     (sum, { score }) => sum + score,
    //     0
    //   ),
    //   category: assessmentType === "assessment" ? "assessment" : "homework",
    //   link: assessmentType === "assessment" ? null : homeworkURL,
    //   // topic: selectedTopics?.id,
    //   topics: topicIds,
    //   number_of_topics: topicIds?.length,
    //   // questionlist: questionIds
    // };

    // addHomeworkAssessment(assessmentData)
    //   .then(
    //     (response: AxiosResponse) => {
    //       // console.log("Response for add assessment: ", response?.data?.data);
    //       pushQuestionsToAssessment(response?.data?.data?.id); // adds question to assessment
    //     },
    //     (error) => {
    //       setIsLoading(false);
    //       if (error?.response?.status === 422) {
    //         toast.error("Can not add assessment! Please check the inputs.");
    //       } else {
    //         toast.error("Can not add assessment! Try again later.");
    //       }
    //       console.log("Error caught: ", error?.response);
    //     }
    //   )
    //   .catch((error) => console.log("Catched error ---> ", error));
  };

  // stores question to the assessment table
  const pushQuestionsToAssessment = (assessmentId: number) => {
    let questionList: any = selectedQuestions?.map(({ id }) => {
      return { assessment_id: assessmentId, question_id: id };
    });
    // console.log("Question Ids: ", questionIds);
    addQuestionsToAssessment(questionList).then(
      (response: AxiosResponse) => {
        console.log(
          "Response for add questions to assessment: ",
          response?.data?.data
        );
        getStudentList(selectedGrade?.grade_section_id?.id, assessmentId); // call to get all student list
      },
      (error) => {
        setIsLoading(false);
        if (error?.response?.status === 422) {
          toast.error(
            "Can not add questions to assessment! Please check the inputs."
          );
        } else {
          toast.error("Can not add questions to assessment! Try again later.");
        }
        console.log("Error caught: ", error?.response);
      }
    );
  };

  // get student list for selected grade-section
  const getStudentList = (grade_section_id: number, assessment_id: number) => {
    getAllStudents(grade_section_id)
      .then(
        (response: AxiosResponse) => {
          // console.log("Response for all student list: ", response?.data?.data);

          let assignedStudentList: TypeAssessmentAttempt[] = [];
          let assignedNotification: TypeNotification[] = [];
          let questionAttemptedList: TypeQuestionAttempt[] = [];

          response?.data?.data?.forEach((eachStudent) => {
            // -- form data to generate assessment for all available students based on grade-section
            let assessmentAttemptBody: TypeAssessmentAttempt = {
              student: eachStudent?.student_profile_id?.user,
              assessment: assessment_id,
            };
            if (homeworkURL && assessmentType === "homework")
              assessmentAttemptBody.link_status = "unattempted";
            assignedStudentList.push(assessmentAttemptBody);

            // -- form data to generate notifications for all available students based on grade-section
            let notificationBody: TypeNotification = {
              title: `New ${
                assessmentType === "assessment" ? "test" : "homework"
              } is available for ${selectedSubject?.subject_id?.name} - ${
                selectedMultipleTopics[0]?.name
              }`,
              type: assessmentType === "assessment" ? "assessment" : "homework",
              student: eachStudent?.student_profile_id?.user,
              seen_status: "unseen",
              extra_data: {
                subject_id: selectedSubject?.subject_id?.id,
                topic_id: selectedMultipleTopics?.map(({ id }) => {
                  return id;
                }),
              },
            };
            assignedNotification.push(notificationBody);

            // -- form data to generate question attempted for each available student
            selectedQuestions?.forEach((eachQuestion) => {
              let questionObj = {
                question: eachQuestion?.id,
                student: eachStudent?.student_profile_id?.user,
                assessment: assessment_id,
              };
              questionAttemptedList.push(questionObj);
            });
          });
          createAssessmentForStudents(
            assignedStudentList,
            assignedNotification
          ); // call for create assessment for all students
          createQuestionAttempts(questionAttemptedList); // call for add question attempted list for all students
        },
        (error) => {
          console.log("Error caught: ", error?.response);
          setIsLoading(false);
          toast.error("Could not create assessment!");
        }
      )
      .catch((error) => {
        console.log("Catched error ---> ", error);
        setIsLoading(false);
      });
  };

  // create assessment for all available students
  const createAssessmentForStudents = (
    list: any,
    assignedNotification: any
  ) => {
    postAssessmentForAllStudents(list)
      .then(
        (response: AxiosResponse) => {
          // console.log("Response for assessment for students: ", response?.data?.data);
          toast.success(
            `${
              assessmentType === "assessment" ? "Assessment" : "Homework"
            } added successfully`
          );

          // let studentIds: number[] = list?.map((each) => each?.student);

          // for real-time notification
          let realTimeNotificationObj = {
            student_ids: list?.map((each) => each?.student),
            title: assessmentTitle,
            assessment_id: list[0]?.assessment,
          };
          // createRealTimeNotification(realTimeNotificationObj);

          // clear states ---
          setAssessmentTitle("");
          setAssessmentDescription("");
          setAssessmentEndDate("");
          setAssessmentTime(5);
          setHomeworkURL("");
          setTotalMarks(0);
          // setAssessmentStartDate('');
          // setAssessmentType('assessment');

          setSelectedQuestions([]);
          setSelectedQuestionLimit(5);
          // setSelectedTopics(null);
          // setSelectedGrade(null);
          // setSelectedSubject(null);
          createNotificationForStudents(assignedNotification);
        },
        (error) => {
          console.log("Error caught: ", error?.response);
          if (error?.response?.status === 422) {
            toast.error("Somathing went wrong!");
          }
          toast.error("Could not create assessment!");
        }
      )
      .catch((error) => console.log("Catched error ---> ", error))
      .finally(() => setIsLoading(false));
  };

  // create question attempt for all available students
  const createQuestionAttempts = (list: TypeQuestionAttempt[]) => {
    createQuestionAttemptsForAllStudents(list).then(
      (response: AxiosResponse) => {
        console.log("Response for question attempts: ", response?.data?.data);
      },
      (error) => {
        console.log("Error caught: ", error?.response);
      }
    );
  };

  // creates notification for all available students
  const createNotificationForStudents = (list: any) => {
    createNotification(list).then(
      (response: AxiosResponse) => {
        // console.log("Response for notification: ", response?.data?.data);
      },
      (error) => {
        console.log("Error caught: ", error?.response);
      }
    );
  };

  // *** CREATES NEW ASSESSMENT ENDS ***

  // search questions
  const searchQuestionsByName = (e) => {
    if (e.key === "Enter") {
      if (searchQuestionQuery.length < 2) {
        setFilteredQuestions([]);
        toast.warning("Enter minimum 3 characters!");
      } else if (searchQuestionQuery.length > 2) {
        setIsQuestionLoading(true);

        // filterQuestions(
        //   selectedGrade?.grade_section_id?.grade?.id,
        //   selectedSubject?.subject_id?.id,
        //   selectedMultipleTopics?.map(({ id }) => id).join(","),
        //   searchQuestionQuery
        // )
        //   .then(
        //     (response: AxiosResponse) => {
        //       console.log(
        //         "Response for question filter: ",
        //         response?.data?.data
        //       );
        //       response?.data?.data.length !== 0
        //         ? setFilteredQuestions(response?.data?.data)
        //         : toast.warning("Could not find any match!");
        //     },
        //     (error) => {
        //       console.log("Error caught: ", error?.response);
        //     }
        //   )
        //   .finally(() => )
        setIsQuestionLoading(false);
      }
    }
  };

  return (
    <React.Fragment>
      <Header />

      <Container className="mt--7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <div className="d-flex justify-content-between align-items-center">
              <>
                {assessmentType === "homework" ? (
                  <h3 className="mb-0 text-muted">
                    <i className="fas fa-pencil-ruler mr-1"></i>Create Homework
                  </h3>
                ) : (
                  <h3 className="mb-0 text-muted">
                    <i className="fas fa-pencil-ruler mr-1"></i> Create
                    Assessment
                  </h3>
                )}
              </>
              <Button
                size="sm"
                color="secondary"
                onClick={() => history.push(PATHS.showAssessments)}
              >
                Cancel <i className="fas fa-times ml-1"></i>{" "}
              </Button>
            </div>

            {/* FILTERS */}
            <div className="p-2 mt-3 rounded filter-div-bg">
              {/* ASSESSMENT TYPE */}
              <Dropdown
                size="sm"
                isOpen={typeDropdownOpen}
                direction="down"
                toggle={assessmentTypeToggle}
              >
                <DropdownToggle caret>
                  {assessmentType ? (
                    <span>
                      Task Type:{" "}
                      <span className="text-primary text-capitalize">
                        {assessmentType}
                      </span>
                    </span>
                  ) : (
                    "Select Assessment Type: "
                  )}
                </DropdownToggle>
                <DropdownMenu style={{ maxHeight: 300, overflow: "auto" }}>
                  <DropdownItem
                    onClick={() => {
                      setAssessmentType("assessment");
                    }}
                  >
                    <span className="d-flex justify-content-between align-items-center">
                      Assessment{" "}
                      {assessmentType === "assessment" && (
                        <i className="fas fa-check-circle text-primary"></i>
                      )}
                    </span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      setAssessmentType("homework");
                    }}
                  >
                    <span className="d-flex justify-content-between align-items-center">
                      Homework{" "}
                      {assessmentType === "homework" && (
                        <i className="fas fa-check-circle text-primary"></i>
                      )}
                    </span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              {/* QUESTION LIMIT */}
              <Dropdown
                size="sm"
                isOpen={questionLimitOpen}
                direction="down"
                toggle={questionLimitToggle}
              >
                <DropdownToggle caret>
                  {selectedQuestionLimit ? (
                    <span>
                      Question Limit:{" "}
                      <span className="text-primary">
                        {selectedQuestionLimit}
                      </span>
                    </span>
                  ) : (
                    "Question Limit"
                  )}
                </DropdownToggle>
                <DropdownMenu style={{ maxHeight: 300, overflow: "auto" }}>
                  {/* <DropdownItem text>Grades</DropdownItem> */}
                  {/* <DropdownItem divider /> */}
                  {questionLimit?.map((each, index) => (
                    <DropdownItem
                      key={index}
                      onClick={() => {
                        setSelectedQuestionLimit(each);
                      }}
                    >
                      <span className="d-flex justify-content-between align-items-center">
                        {each}{" "}
                        {selectedQuestionLimit === each && (
                          <i className="fas fa-check-circle text-primary"></i>
                        )}
                      </span>
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              {/* FOR GRADES */}
              <Dropdown
                size="sm"
                isOpen={gradeDropdownOpen}
                direction="down"
                toggle={gradeDropdownToggle}
              >
                <DropdownToggle caret>
                  {selectedGrade ? (
                    <span>
                      Selected Grade:{" "}
                      <span className="text-primary">
                        {selectedGrade?.grade_section_id?.grade?.name} -{" "}
                        {selectedGrade?.grade_section_id?.section?.type}
                      </span>
                    </span>
                  ) : (
                    "Select Grade"
                  )}
                </DropdownToggle>
                <DropdownMenu style={{ maxHeight: 300, overflow: "auto" }}>
                  {gradeSectionInfo?.length !== 0 ? (
                    gradeSectionInfo?.map((each, index) => (
                      <DropdownItem
                        key={index}
                        onClick={() => setSelectedGrade(each)}
                      >
                        <span className="d-flex justify-content-between align-items-center">
                          {each?.grade_section_id?.grade?.name} -{" "}
                          {each?.grade_section_id?.section?.type}
                          {selectedGrade?.grade_section_id?.id ===
                            each?.grade_section_id?.id && (
                            <i className="fas fa-check-circle text-primary"></i>
                          )}
                        </span>
                      </DropdownItem>
                    ))
                  ) : (
                    <span className="small text-muted text-center">
                      No Grades Available
                    </span>
                  )}
                </DropdownMenu>
              </Dropdown>
              {/* FOR SUBJECTS */}
              <Dropdown
                size="sm"
                isOpen={subjectDropdownOpen}
                direction="down"
                toggle={subjectDropdownToggle}
              >
                <DropdownToggle caret>
                  {selectedSubject ? (
                    <span>
                      Selected Subject:{" "}
                      <span className="text-primary">
                        {selectedSubject?.subject_id?.name}
                      </span>
                    </span>
                  ) : (
                    "Select Subject"
                  )}
                </DropdownToggle>
                <DropdownMenu style={{ maxHeight: 300, overflow: "auto" }}>
                  {subjects?.length !== 0 ? (
                    subjects?.map((each, index) => (
                      <DropdownItem
                        key={index}
                        onClick={() => setSelectedSubject(each)}
                      >
                        <span className="d-flex justify-content-between align-items-center">
                          {each?.subject_id?.name}{" "}
                          {selectedSubject?.subject_id?.id ===
                            each?.subject_id?.id && (
                            <i className="fas fa-check-circle text-primary"></i>
                          )}
                        </span>
                      </DropdownItem>
                    ))
                  ) : (
                    <span className="small text-muted text-center">
                      Please select a grade first
                    </span>
                  )}
                </DropdownMenu>
              </Dropdown>
              {/* FOR TOPICS */}
              <Dropdown
                size="sm"
                isOpen={topicDropdownOpen}
                direction="left"
                toggle={topicDropdownToggle}
              >
                <DropdownToggle caret>
                  {selectedMultipleTopics ? (
                    <span>
                      Selected Topic:{" "}
                      <span className="text-primary">
                        {selectedMultipleTopics[0]?.name}
                      </span>
                    </span>
                  ) : (
                    "Select Topic"
                  )}
                </DropdownToggle>
                <DropdownMenu style={{ maxHeight: 300, overflow: "auto" }}>
                  {selectedMultipleTopics?.length ? (
                    <DropdownItem
                      className="d-flex justify-content-center align-items-center font-weight-bold bg-light"
                      onClick={() => setSelectedMultipleTopics([])}
                    >
                      Clear{" "}
                      <i className="fas fa-times-circle text-danger ml-1"></i>
                    </DropdownItem>
                  ) : (
                    <></>
                  )}
                  {topics?.length !== 0 ? (
                    topics?.map((each, index) => (
                      // <DropdownItem key={index} onClick={() => addSelectedTopics(each)}>
                      <DropdownItem
                        key={index}
                        onClick={() => addSelectedMultipleTopics(each)}
                        disabled={selectedMultipleTopics?.length ? true : false}
                      >
                        <span className="d-flex justify-content-between align-items-center">
                          {each?.name}{" "}
                          {selectedMultipleTopics[0]?.id === each?.id && (
                            <i className="fas fa-check-circle text-primary"></i>
                          )}
                        </span>
                      </DropdownItem>
                    ))
                  ) : (
                    <span className="small text-muted text-center">
                      Please select a grade and subject first
                    </span>
                  )}
                </DropdownMenu>
              </Dropdown>

              <Button color="primary" onClick={homeworkModalToggle} size="sm">
                View Questions <i className="fas fa-question-circle"></i>
              </Button>
            </div>
          </CardHeader>
          <CardBody className="pt-0">
            <Row>
              <Col>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    confirmAddAssessmentModalToggle();
                  }}
                >
                  {!assessmentType ? (
                    <div className="bg-warning">Adaptive</div>
                  ) : (
                    <React.Fragment>
                      {/* ASSESSMENT INFORMATION */}
                      <div>
                        <Row>
                          <Col md="4" sm="12">
                            <FormGroup>
                              <Label
                                className="small font-weight-bold"
                                htmlFor="input-startDate"
                              >
                                Start Date-Time
                              </Label>
                              <Input
                                id="input-startDate"
                                type="datetime-local"
                                className={
                                  assessmentStartDate ? "" : "border-danger"
                                }
                                min={new Date()
                                  .toISOString()
                                  .split(".")[0]
                                  .split("T")[0]
                                  .concat("T00:00:00")}
                                // new Date().toISOString().split('.')[0].slice(0, new Date().toISOString().split('.')[0].length - 3)
                                value={assessmentStartDate}
                                onChange={(e) => {
                                  setAssessmentStartDate(e.target.value);
                                }}
                              ></Input>
                            </FormGroup>
                          </Col>
                          <Col md="4" sm="12">
                            <FormGroup>
                              <Label
                                className="small font-weight-bold"
                                htmlFor="dueDate"
                              >
                                Due Date-Time
                              </Label>
                              <Input
                                id="dueDate"
                                type="datetime-local"
                                className={
                                  assessmentEndDate < assessmentStartDate
                                    ? "border-danger"
                                    : ""
                                }
                                min={assessmentStartDate} // new Date().toISOString().split('.')[0].slice(0, new Date().toISOString().split('.')[0].length - 3)
                                value={assessmentEndDate} // assessment start date
                                onChange={(e) => {
                                  setAssessmentEndDate(e.target.value);
                                }}
                              ></Input>
                            </FormGroup>
                          </Col>
                          <Col md="4" sm="12">
                            <FormGroup>
                              {assessmentType === "assessment" ? (
                                <React.Fragment>
                                  <Label
                                    className="small font-weight-bold"
                                    htmlFor="duration"
                                  >
                                    Duration (In Minutes)
                                  </Label>
                                  <Input
                                    id="duration"
                                    type="number"
                                    className=""
                                    min="0"
                                    value={assessmentTime}
                                    onChange={(e) =>
                                      setAssessmentTime(Number(e.target.value))
                                    }
                                  ></Input>
                                  <p className="small text-muted">
                                    0 minute for untimed assessment
                                  </p>
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  <Label
                                    className="small font-weight-bold"
                                    htmlFor="url"
                                  >
                                    URL
                                  </Label>
                                  <Input
                                    id="url"
                                    type="url"
                                    className=""
                                    value={homeworkURL}
                                    onChange={(e) =>
                                      setHomeworkURL(e.target.value)
                                    }
                                  ></Input>
                                </React.Fragment>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6" sm="12">
                            <FormGroup>
                              <Label
                                className="small font-weight-bold"
                                htmlFor="title"
                              >
                                Title
                              </Label>
                              <Input
                                id="title"
                                type="text"
                                className={
                                  assessmentTitle ? "" : "border-danger"
                                }
                                required
                                placeholder="Enter title"
                                value={assessmentTitle}
                                onChange={(e) => {
                                  setAssessmentTitle(e.target.value);
                                }}
                              ></Input>
                            </FormGroup>
                          </Col>
                          <Col md="6" sm="12">
                            <FormGroup>
                              <Label
                                className="small font-weight-bold"
                                htmlFor="description"
                              >
                                Description
                              </Label>
                              <Input
                                type="textarea"
                                id="description"
                                placeholder="Enter description"
                                value={assessmentDescription}
                                onChange={(e) => {
                                  setAssessmentDescription(e.target.value);
                                }}
                              ></Input>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>

                      {/* MODAL FOR SHOWING QUESTION LIST */}
                      <div>
                        <Modal
                          className="question-modal-bg"
                          isOpen={homeworkModal}
                          toggle={homeworkModalToggle}
                          size="lg"
                          scrollable={true}
                        >
                          <ModalHeader
                            className="bg-white"
                            toggle={homeworkModalToggle}
                          >
                            Question List
                          </ModalHeader>
                          <ModalBody className="bg-white">
                            {/* <div className="d-flex align-items-center"> */}
                            <Row>
                              <Col sm="12">
                                <InputGroup className="mb-2">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                      <Search />
                                    </InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    placeholder="Search Questions"
                                    value={searchQuestionQuery}
                                    onChange={(e) =>
                                      setSearchQuestionQuery(e.target.value)
                                    }
                                    onKeyUp={(e) => searchQuestionsByName(e)}
                                  />
                                  {searchQuestionQuery ? (
                                    <InputGroupAddon
                                      addonType="append"
                                      className="pointer"
                                      onClick={() => {
                                        setFilteredQuestions([]);
                                        setSearchQuestionQuery("");
                                      }}
                                    >
                                      <InputGroupText>
                                        <i className="fas fa-times"></i>
                                      </InputGroupText>
                                    </InputGroupAddon>
                                  ) : (
                                    <></>
                                  )}
                                </InputGroup>
                                {/* { filteredQuestions.length !== 0 ? <Button color="secondary" onClick={() => setFilteredQuestions([])}>Cancel</Button>: <></> } */}
                              </Col>
                            </Row>
                            {/* </div> */}

                            {!isQuestionLoading ? (
                              filteredQuestions.length === 0 ? (
                                homeworkQuestions?.map(
                                  (each: TypeQuestions, index: number) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <ListGroup className="mb-2">
                                          <ListGroupItem className="bg-gradient-info">
                                            <ListGroupItemHeading className="d-flex justify-content-between align-items-center text-muted">
                                              <span className="d-flex align-items-center text-white">
                                                <Book
                                                  className="mr-1"
                                                  size="15"
                                                />{" "}
                                                Question {index + 1}
                                              </span>
                                              <div>
                                                <Badge
                                                  color="light"
                                                  className="bg-white text-dark mr-2"
                                                >
                                                  Marks: {each?.score}
                                                </Badge>
                                                <Badge
                                                  color="light"
                                                  className="bg-white text-dark"
                                                >
                                                  Difficulty:{" "}
                                                  {each?.difficulty_level_1_3 ===
                                                  1
                                                    ? "Easy"
                                                    : each?.difficulty_level_1_3 ===
                                                      2
                                                    ? "Medium"
                                                    : "Hard"}
                                                </Badge>
                                              </div>
                                            </ListGroupItemHeading>
                                            <ListGroupItemText>
                                              <p className="font-weight-bold text-white">
                                                <span
                                                  dangerouslySetInnerHTML={createMarkup(
                                                    each?.question
                                                  )}
                                                />
                                              </p>
                                              <div
                                                className="d-flex align-items-center mr-1 text-white pointer underline"
                                                onClick={() =>
                                                  setIsOptionOpen(index)
                                                }
                                              >
                                                <u>View Options:</u>
                                              </div>{" "}
                                              {/* <i className="fas fa-long-arrow-alt-down"></i> */}
                                              {isOptionOpen === index ? (
                                                <div>
                                                  <div
                                                    className={
                                                      "text-white border p-2 my-1 " +
                                                      (each?.correct_option ===
                                                      "a"
                                                        ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                        : "")
                                                    }
                                                  >
                                                    <span
                                                      dangerouslySetInnerHTML={createMarkup(
                                                        each?.option_a
                                                      )}
                                                    />
                                                  </div>
                                                  <div
                                                    className={
                                                      "text-white border p-2 my-1" +
                                                      (each?.correct_option ===
                                                      "b"
                                                        ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                        : "")
                                                    }
                                                  >
                                                    <span
                                                      dangerouslySetInnerHTML={createMarkup(
                                                        each?.option_b
                                                      )}
                                                    />
                                                  </div>
                                                  <div
                                                    className={
                                                      "text-white border p-2 my-1" +
                                                      (each?.correct_option ===
                                                      "c"
                                                        ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                        : "")
                                                    }
                                                  >
                                                    <span
                                                      dangerouslySetInnerHTML={createMarkup(
                                                        each?.option_c
                                                      )}
                                                    />
                                                  </div>
                                                  <div
                                                    className={
                                                      "text-white  border p-2 my-1" +
                                                      (each?.correct_option ===
                                                      "d"
                                                        ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                        : "")
                                                    }
                                                  >
                                                    <span
                                                      dangerouslySetInnerHTML={createMarkup(
                                                        each?.option_d
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                              ) : (
                                                <></>
                                              )}
                                            </ListGroupItemText>
                                            {selectedQuestions?.some(
                                              (e) => e.id === each?.id
                                            ) ? (
                                              <Button
                                                color="warning float-right"
                                                size="sm"
                                                disabled
                                              >
                                                Added{" "}
                                                <i className="fas fa-check-circle"></i>
                                              </Button>
                                            ) : selectedQuestions.length !==
                                              selectedQuestionLimit ? (
                                              <Button
                                                color="primary float-right"
                                                size="sm"
                                                onClick={() => {
                                                  addSelectedQuestions(each);
                                                  setTotalMarks(
                                                    totalMarks + each?.score
                                                  );
                                                }}
                                              >
                                                Add{" "}
                                                <i className="fas fa-plus-square pl-2"></i>
                                              </Button>
                                            ) : (
                                              <p className="float-right text-danger font-weight-bold">
                                                Reached Question Limit
                                              </p>
                                            )}
                                            {selectedQuestions?.some(
                                              (e) => e.id === each?.id
                                            ) ? (
                                              <Button
                                                color="danger float-right mr-2"
                                                size="sm"
                                                onClick={() => {
                                                  removeSelectedQuestion(each);
                                                  setTotalMarks(
                                                    totalMarks - each?.score
                                                  );
                                                }}
                                              >
                                                Remove{" "}
                                                <i className="fas fa-times-circle"></i>
                                              </Button>
                                            ) : (
                                              <></>
                                            )}
                                          </ListGroupItem>
                                        </ListGroup>
                                      </React.Fragment>
                                    );
                                  }
                                )
                              ) : (
                                filteredQuestions?.map(
                                  (each: TypeQuestions, index: number) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <ListGroup className="mb-2">
                                          <ListGroupItem className="bg-gradient-info">
                                            <ListGroupItemHeading className="d-flex justify-content-between align-items-center text-muted">
                                              {/* <span className="d-flex align-items-baseline"><i className="fas fa-question-circle pr-2" style={{ fontSize: 18 }}></i> Question {index + 1}</span> */}
                                              <span className="d-flex align-items-center text-white">
                                                <Book
                                                  className="mr-1"
                                                  size="15"
                                                />{" "}
                                                Question {index + 1}
                                              </span>
                                              <div>
                                                <Badge
                                                  color="light"
                                                  className="bg-white text-dark mr-2"
                                                >
                                                  Marks: {each?.score}
                                                </Badge>
                                                <Badge
                                                  color="light"
                                                  className="bg-white text-dark"
                                                >
                                                  Difficulty:{" "}
                                                  {each?.difficulty_level_1_3 ===
                                                  1
                                                    ? "Easy"
                                                    : each?.difficulty_level_1_3 ===
                                                      2
                                                    ? "Medium"
                                                    : "Hard"}
                                                </Badge>
                                              </div>
                                            </ListGroupItemHeading>
                                            <ListGroupItemText>
                                              <p className="font-weight-bold text-white">
                                                <span
                                                  dangerouslySetInnerHTML={createMarkup(
                                                    each?.question
                                                  )}
                                                />
                                              </p>
                                              <div
                                                className="text-white pointer"
                                                onClick={() =>
                                                  setIsOptionOpen(index)
                                                }
                                              >
                                                View Options:{" "}
                                              </div>
                                              {isOptionOpen === index ? (
                                                <div>
                                                  <div
                                                    className={
                                                      "text-white border p-2 my-1 " +
                                                      (each?.correct_option ===
                                                      "a"
                                                        ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                        : "")
                                                    }
                                                  >
                                                    <span
                                                      dangerouslySetInnerHTML={createMarkup(
                                                        each?.option_a
                                                      )}
                                                    />
                                                  </div>
                                                  <div
                                                    className={
                                                      "text-white border p-2 my-1" +
                                                      (each?.correct_option ===
                                                      "b"
                                                        ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                        : "")
                                                    }
                                                  >
                                                    <span
                                                      dangerouslySetInnerHTML={createMarkup(
                                                        each?.option_b
                                                      )}
                                                    />
                                                  </div>
                                                  <div
                                                    className={
                                                      "text-white border p-2 my-1" +
                                                      (each?.correct_option ===
                                                      "c"
                                                        ? " font-weight-bold  border-success-4 rightQuestion-bg"
                                                        : "")
                                                    }
                                                  >
                                                    <span
                                                      dangerouslySetInnerHTML={createMarkup(
                                                        each?.option_c
                                                      )}
                                                    />
                                                  </div>
                                                  <div
                                                    className={
                                                      "text-white  border p-2 my-1" +
                                                      (each?.correct_option ===
                                                      "d"
                                                        ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                        : "")
                                                    }
                                                  >
                                                    <span
                                                      dangerouslySetInnerHTML={createMarkup(
                                                        each?.option_d
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                              ) : (
                                                <></>
                                              )}
                                            </ListGroupItemText>
                                            {selectedQuestions?.some(
                                              (e) => e.id === each?.id
                                            ) ? (
                                              <Button
                                                color="warning float-right"
                                                size="sm"
                                                disabled
                                              >
                                                Added{" "}
                                                <i className="fas fa-check-circle"></i>
                                              </Button>
                                            ) : selectedQuestions.length !==
                                              selectedQuestionLimit ? (
                                              <Button
                                                color="primary float-right"
                                                size="sm"
                                                onClick={() => {
                                                  addSelectedQuestions(each);
                                                  setTotalMarks(
                                                    totalMarks + each?.score
                                                  );
                                                }}
                                              >
                                                Add{" "}
                                                <i className="fas fa-plus-square pl-2"></i>
                                              </Button>
                                            ) : (
                                              <p className="float-right text-danger font-weight-bold">
                                                Reached Question Limit
                                              </p>
                                            )}
                                            {selectedQuestions?.some(
                                              (e) => e.id === each?.id
                                            ) ? (
                                              <Button
                                                color="danger float-right mr-2"
                                                size="sm"
                                                onClick={() => {
                                                  removeSelectedQuestion(each);
                                                  setTotalMarks(
                                                    totalMarks - each?.score
                                                  );
                                                }}
                                              >
                                                Remove{" "}
                                                <i className="fas fa-times-circle"></i>
                                              </Button>
                                            ) : (
                                              <></>
                                            )}
                                          </ListGroupItem>
                                        </ListGroup>
                                      </React.Fragment>
                                    );
                                  }
                                )
                              )
                            ) : (
                              <DotsSpinner />
                            )}
                            {homeworkQuestions.length === 0 && (
                              <span className="d-flex justify-content-center align-items-center text-muted">
                                Please select grade, subject and topic to see
                                the questions
                              </span>
                            )}
                          </ModalBody>
                          <ModalFooter className="bg-white">
                            <Button
                              color="secondary"
                              onClick={homeworkModalToggle}
                            >
                              Close
                            </Button>
                          </ModalFooter>
                        </Modal>
                      </div>

                      {/* SHOW SELECTED QUESTIONS */}
                      <div className="d-flex justify-content-between align-items-center">
                        <h4 className="text-muted">Selected Questions</h4>
                        <Label className="small font-weight-bold text-muted">
                          Total Marks:{" "}
                          <span className="text-primary">{totalMarks}</span>
                        </Label>
                      </div>
                      {selectedQuestions.length > 0 ? (
                        <div
                          className="overflow-auto"
                          style={{ maxHeight: 500 }}
                        >
                          {selectedQuestions?.map(
                            (each: TypeQuestions, index: number) => {
                              return (
                                <ListGroup className="mb-2" key={index}>
                                  <ListGroupItem className="bg-gradient-info">
                                    <ListGroupItemHeading className="d-flex justify-content-between align-items-center text-muted">
                                      <span className="d-flex align-items-center text-white">
                                        <Book className="mr-1" size="15" />{" "}
                                        Question {index + 1}
                                      </span>
                                      <div>
                                        <Badge
                                          color="light"
                                          className="bg-white text-dark mr-2"
                                        >
                                          Marks: {each?.score}
                                        </Badge>
                                        <Badge
                                          color="light"
                                          className="bg-white text-dark"
                                        >
                                          Difficulty:{" "}
                                          {each?.difficulty_level_1_3 === 1
                                            ? "Easy"
                                            : each?.difficulty_level_1_3 === 2
                                            ? "Medium"
                                            : "Hard"}
                                        </Badge>
                                      </div>
                                    </ListGroupItemHeading>
                                    <ListGroupItemText>
                                      <p className="font-weight-bold text-white">
                                        <span
                                          dangerouslySetInnerHTML={createMarkup(
                                            each?.question
                                          )}
                                        />
                                      </p>
                                      <div
                                        className="text-white pointer"
                                        onClick={() =>
                                          setIsViewOptionOpen(index)
                                        }
                                      >
                                        View Options:{" "}
                                      </div>
                                      {isViewOptionOpen === index ? (
                                        <div>
                                          <div
                                            className={
                                              "text-white border p-2 my-1 " +
                                              (each?.correct_option === "a"
                                                ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                : "")
                                            }
                                          >
                                            <span
                                              dangerouslySetInnerHTML={createMarkup(
                                                each?.option_a
                                              )}
                                            />
                                          </div>
                                          <div
                                            className={
                                              "text-white border p-2 my-1" +
                                              (each?.correct_option === "b"
                                                ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                : "")
                                            }
                                          >
                                            <span
                                              dangerouslySetInnerHTML={createMarkup(
                                                each?.option_b
                                              )}
                                            />
                                          </div>
                                          <div
                                            className={
                                              "text-white border p-2 my-1" +
                                              (each?.correct_option === "c"
                                                ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                : "")
                                            }
                                          >
                                            <span
                                              dangerouslySetInnerHTML={createMarkup(
                                                each?.option_c
                                              )}
                                            />
                                          </div>
                                          <div
                                            className={
                                              "text-white  border p-2 my-1" +
                                              (each?.correct_option === "d"
                                                ? " font-weight-bold border-success-4 rightQuestion-bg"
                                                : "")
                                            }
                                          >
                                            <span
                                              dangerouslySetInnerHTML={createMarkup(
                                                each?.option_d
                                              )}
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </ListGroupItemText>
                                    <Button
                                      color="danger float-right mr-2"
                                      size="sm"
                                      onClick={() => {
                                        removeSelectedQuestion(each);
                                        setTotalMarks(totalMarks - each?.score);
                                      }}
                                    >
                                      Remove{" "}
                                      <i className="fas fa-times-circle"></i>
                                    </Button>
                                  </ListGroupItem>
                                </ListGroup>
                              );
                            }
                          )}
                        </div>
                      ) : (
                        <p>You have not selected any question yet.</p>
                      )}
                    </React.Fragment>
                  )}

                  {/* SAVE THE ASSESSMENT/HOMEWORK */}
                  {!isLoading ? (
                    assessmentType !== "homework" &&
                    selectedQuestions.length < selectedQuestionLimit ? (
                      <Button
                        color="primary"
                        outline
                        // size="sm"
                        className="mt-3 float-right"
                        onClick={homeworkModalToggle}
                      >
                        Please select{" "}
                        {selectedQuestionLimit - selectedQuestions.length} more
                        question
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        color="primary"
                        className="mt-3 float-right"
                        disabled={
                          !assessmentTitle || !assessmentEndDate ? true : false
                        }
                      >
                        {/* selectedQuestions.length < selectedQuestionLimit ||  || !assessmentDescription  */}
                        Generate{" "}
                        {assessmentType === "assessment"
                          ? "Assessment"
                          : "Homework"}{" "}
                        <i className="fas fa-save"></i>
                      </Button>
                    )
                  ) : (
                    <Button
                      className="mt-3 mx-3 float-right"
                      color="primary"
                      type="button"
                    >
                      <div
                        className="spinner-border rounded-circle spinner-border-sm"
                        role="status"
                      >
                        <p className="sr-only">Loading...</p>
                      </div>
                    </Button>
                  )}
                </Form>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* CONFIRMATION MODAL */}
        <ConfirmModal
          isOpen={confirmAddAssessmentModal}
          onClose={() => setConfirmAddAssessmentModal(false)}
          type={"add"}
          title={`Are you sure you want to add this ${
            assessmentType === "assessment" ? "assessment?" : "homework?"
          }`}
          onConfirm={() => {
            setConfirmAddAssessmentModal(false);
            addAssessmentInfo();
          }}
        />
      </Container>
    </React.Fragment>
  );
}
